import '../../asset/css/table.css';
import '../../asset/css/style.css';

import { Spin, Table, Tooltip } from 'antd';

import Constant from '../../util/Constant.json';
import React from 'react';
import SiteAPI from '../../service/Sites';
import { getURL } from '../../util/index';
import jp from "jsonpath";

const ERROE_FILTER_PATH = '@.error =="E" || @.warehouse=="EW" || @.warehouse=="EWCN" || @.warehouse=="EWAU" || @.ledger=="EL"'

class DaySites extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sites: [],
            isAPICallNeeded: false,
            loader: true
        };
        // console.log("DaySites :: ", this.props);
    }


    getJSONPathFilterExpression(selectedFlags) {

        // console.log(selectedFlags)
        let filterExpression = '$.x[?(';
        selectedFlags.forEach((flag, index) => {
            // console.log(flag.flagName === 'error')
            filterExpression = filterExpression + (index === 0 ?
                flag.flagName === 'error' ? ERROE_FILTER_PATH : `@.${flag.flagName}` :
                flag.flagName === 'error' ? '|| ' + ERROE_FILTER_PATH : ` || @.${flag.flagName}`)
        });
        return filterExpression + ')]'
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.isAPICallNeeded !== this.state.isAPICallNeeded) {
            this.setState({ loader: true, isAPICallNeeded: this.props.isAPICallNeeded, sites: [] }, async () => {
                this.setState({ sites: await this.getSiteAPIResponse(), loader: false })
            });;
        }
    }

    async getSiteAPIResponse() {
        const sidebarDataResponse = JSON.parse(localStorage.getItem('sideBarData')).message;
        const { country, selectedDate, selectedFlags, filterData } = this.props;
        let { siteName, status } = filterData
        let tempStatus = status.length ? (status.length > 1 ? "0,1" : (status[0] === "Active" ? "1" : "0")) : "0,1"
        let url = getURL(Constant.URL.GET_DAY_SITE_DATA);
        url.searchParams.append('countryIso', sidebarDataResponse[country].countryIso);
        url.searchParams.append('fromDate', selectedDate);
        url.searchParams.append('Status', tempStatus);
        let result = await SiteAPI.getDayData(url.href, {});
 
        let filterResponse = [];
        if (result.response?.regions) {
            let sites = result.response.regions[0].countries[0].sites;
            sites = sites.active.concat(sites.inactive);
            filterResponse = (siteName?.length) ?
              (selectedFlags?.length ? jp.query({ x: jp.query({ x: sites }, this.getSiteNameJSONFilterExpression(siteName)) }, this.getJSONPathFilterExpression(selectedFlags)) : jp.query({ x: sites }, this.getSiteNameJSONFilterExpression(siteName)))
                : (selectedFlags?.length) ? jp.query({ x: sites }, this.getJSONPathFilterExpression(selectedFlags)) : sites;
        }

        // console.log('getSiteAPIResponse', filterResponse)

        return filterResponse;
    }

    getSiteNameJSONFilterExpression = (selectedSites) => {

        let filterExpression = '$..[?(';
        selectedSites.forEach((site, index) => {
            filterExpression = filterExpression + (index === 0 ? `@.SiteName=="${site}"` : ` || @.SiteName=="${site}"`)
        });

        filterExpression = filterExpression + ')]';
        return filterExpression;
    }

    async componentDidMount() {
        this.setState({ sites: await this.getSiteAPIResponse(), isAPICallNeeded: this.props.isAPICallNeeded, loader: false });;
    }


    render() {

        if (this.state.loader) {
            return <div style={{ textAlign: "center" }}><Spin spin={true} size='large' /></div>
        } else {
            const stores = this.state;
            
            let columns = [
                { title: 'Stores', dataIndex: 'name', key: 'name', width: 300, render: text => <p style={{ float: "left" }}>{text}</p> },

            ];

            columns = [...columns, {
                title: 'Missing', dataIndex: 'missing', key: 'missing ', width: 100,

                render(text, record) {
                    return {
                        props: {
                            style: text ? { background: "Yellow", padding: "10px" } : { background: "", padding: "10px" }
                        },
                        children: <Tooltip title={text}><a>{text}</a></Tooltip>
                    };
                },
                onCell: (record, rowIndex) => {
                    return {
                        onClick: (e) => {
                            // console.log("Click Me Missing :: ", record, " -- ", rowIndex);
                            this.props.setAuditDetails(record, this.props.country, this.props.region, record.missing);
                        }
                    }
                }
            },
            {
                title: 'Closed', dataIndex: 'closed', key: 'closed ',
                render(text, record) {
                    return {
                        props: {
                            style: text ? { background: "Gray", padding: "10px" } : { background: "", padding: "10px" }
                        },
                        children: <Tooltip title={text}><a>{text}</a></Tooltip>
                    };
                }
            },
            {
                title: 'Error', dataIndex: 'error', key: 'error ',
                render(text, record) {
                    return {
                        props: {
                            style: text ? { background: "rgba(221,12,12,.815)", padding: "10px" } : { background: "", padding: "10px" }
                        },
                        children: <Tooltip title={text}><a>{text}</a></Tooltip>
                    };
                },
                onCell: (record, rowIndex) => {
                    return {
                        onClick: (e) => {
                            this.props.setAuditDetails(record, this.props.country, this.props.region, record.error);
                        }
                    }
                }
            },
            {
                title: 'Warehouse', dataIndex: 'warehouse', key: 'warehouse ',
                render(text, record) {
                    return {
                        props: {
                            style: text && ["EW", "EWCN", "EWAU"].includes(text) ? { background: "orange", padding: "10px" } : text && text === "IP" ? { background: "#8aacfa", padding: "10px" } : { background: "", padding: "10px" }
                        },
                        children: <Tooltip title={text}><a>{text}</a></Tooltip>
                    };
                },
                onCell: (record, rowIndex) => {
                    // console.log("Warehouse :: ", record);
                    if(record.warehouse !== "Y") {
                        return {
                            onClick: (e) => {
                                // console.log("Click Me Missing :: ", record, " -- ", rowIndex);
                                this.props.setAuditDetails(record, this.props.country, this.props.region, record.warehouse);
                            }
                        }
                    }
                    
                }
            },
            {
                title: 'Ledger', dataIndex: 'ledger', key: 'ledger',
                render(text, record) {
                    return {
                        props: {
                            style: text && text === "EL" ? { background: "red", padding: "10px" } : text && text === "IP" ? { background: "#8aacfa", padding: "10px" } : { background: "", padding: "10px" }
                        },
                        children: <Tooltip title={text}><a>{text}</a></Tooltip>
                    };
                },
                onCell: (record, rowIndex) => {
                    if(record.ledger !== "Y") {
                        return {
                            onClick: (e) => {
                                // console.log("Click Me Missing :: ", record, " -- ", rowIndex);
                                this.props.setAuditDetails(record, this.props.country, this.props.region, record.ledger);
                            }
                        }
                    }
                }
            },
            {
                title: 'Oracle', dataIndex: 'oracleFinance', key: 'oracleFinance',
                render(text, record) {
                    return {
                        props: {
                            style: text && text === "EO" ? { background: "#e2321e", padding: "10px" } : text && text === "IP" ? { background: "#8aacfa", padding: "10px" } : { background: "", padding: "10px" }
                        },
                        children: <Tooltip title={text}><a>{text}</a></Tooltip>
                    };
                },
                onCell: (record, rowIndex) => {
                    if(record.oracleFinance !== "Y") {
                        return {
                            onClick: (e) => {
                                // console.log("Click Me  :: ", record, " -- ", rowIndex);
                                this.props.setAuditDetails(record, this.props.country, this.props.region, record.oracleFinance);
                            }
                        }
                    }
                }
            }
        
        ]

            const siteIds = stores.sites.map((site, index) => {
            // const siteIds = storesTemp.sites.map((site, index) => {

            // console.log('site', site)

                const result= {
                    key: index,
                    siteId: site.SiteId,
                    name: site.SiteName,
                    missing: jp.query(site, '$..missing')[0],
                    closed: jp.query(site, '$..closed')[0],
                    processing: jp.query(site, '$..processing')[0],
                    error: jp.query(site, '$..error')[0],
                    warehouse: jp.query(site, '$..warehouse')[0],
                    ledger: jp.query(site, '$..ledger')[0],
                    oracleFinance: jp.query(site, '$..oracleFinance')[0],
                }
                // console.log('result', result)

                return result;
            })

            return <div className="storeTable">
                <Table
                    className="test"
                    size={"small"}
                    bordered="true"
                    columns={columns}
                    dataSource={siteIds}
                    pagination={false}
                    scroll={{
                        y: 240
                    }} />
            </div>
        }
    }
}


export default DaySites;